import React from 'react';

const Lectures = () => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24"
      style={{ enableBackground: 'new 0 0 24 24' }} xmlSpace="preserve">
      <path className="st0" d="M4,19.5C4,18.1,5.1,17,6.5,17H20" />
      <path className="st0" d="M6.5,2H20v20H6.5C5.1,22,4,20.9,4,19.5v-15C4,3.1,5.1,2,6.5,2z" />
    </svg>
  );
};

export default Lectures;